const styles = (theme) => ({
  label: {
    color: theme.colors.info__label_primary,
    display: 'inline'
  },
  'dark-label': {
    color: `${theme.colors.light_text} !important`
  },
  container: {
    marginTop: 0
  }
});

export default styles;
